import * as React from 'react'
import {Link} from 'react-router-dom'

import styled from 'styled-components/macro'
import Logo from 'assets/images/Logo1.svg'
import {QUERIES} from 'common/constants'
import ServicesDropdown from 'common/ServicesDropdown'
import MobileMenu from 'common/MobileMenu'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: absolute;
  top: 0;
  background-color: 'black';
  @media ${QUERIES.tabletAndUp} {
    top: 50px;
    background-color: inherit;
  }
`

const HorizontalMenu = styled.div`
  display: none;
  color: var(--white);
  @media ${QUERIES.tabletAndUp} {
    display: flex;
    justify-content: center;
  }
  width: 100%;
`

const MenuItem = styled(Link)`
  font-family: 'Rubik';
  font-style: italic;
  font-weight: 400;
  font-size: 1rem;
  text-transform: uppercase;
  line-height: 19px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  text-decoration: none;
  border-radius: 5px;
  :hover {
    background-color: hsla(0, 0%, 100%, 0.25);
  }
`

const MenuItemDropdown = styled.div`
  font-family: 'Rubik';
  font-style: italic;
  font-weight: 400;
  font-size: 1rem;
  text-transform: uppercase;
  line-height: 19px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  text-decoration: none;
  border-radius: 5px;
  cursor: pointer;
  :hover {
    background-color: hsla(0, 0%, 100%, 0.25);
  }
  background-color: ${p =>
    p.active === 'true' ? 'hsla(0, 0%, 100%, 0.25)' : 'intial'};
  position: relative;
`

const HomePageMenu = () => {
  const [showServices, setShowServices] = React.useState(false)

  const toggleServicesDropdown = () => {
    setShowServices(!showServices)
  }
  return (
    <Container>
      <HorizontalMenu>
        <MenuItemDropdown
          onClick={toggleServicesDropdown}
          active={String(showServices)}
        >
          Services <ServicesDropdown visible={showServices} />
        </MenuItemDropdown>
        {/* <MenuItem
          as={'a'}
          href="https://shop.golfinvite.com"
          target="_blank"
          rel="noreferrer"
        >
          Shop
        </MenuItem> */}
        <MenuItem to="/shop">Shop</MenuItem>
        <img src={Logo} alt="Golf Invite Logo" />
        <MenuItem to="/about">About</MenuItem>
        <MenuItem to="/contact">Contact</MenuItem>
      </HorizontalMenu>
      <MobileMenu />
    </Container>
  )
}
export default HomePageMenu
